import { Directive, HostListener } from '@angular/core';

@Directive({
  selector: '[appNumericOnly]',
})
export class NumericValueOnlyDirective  {

@HostListener('input', ['$event']) onInput(event: KeyboardEvent) {
  const input = event.target as HTMLInputElement;
  const originalValue = input.value;

  let newValue = originalValue.replace(/[^0-9.]/g, '');

  const [integerPart, decimalPart] = newValue.split('.');

  newValue = integerPart.slice(0, 5);

  if (decimalPart !== undefined) {
    newValue += '.' + decimalPart;
  }

  if (originalValue !== newValue) {
    input.value = newValue;
    event.stopPropagation();
  }
}
}


